import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import { BadgeCheck } from "lucide-react";

const VerifiedBadgeCheck = ({ iconClassName }: { iconClassName?: string }) => {
	return (
		<TooltipProvider>
			<Tooltip>
				<TooltipTrigger>
					<span>
						<BadgeCheck className={cn("h-7 w-7 fill-blue-500 text-white", iconClassName)} />
					</span>
				</TooltipTrigger>
				<TooltipContent className="bg-white shadow">
					<p className="text-gray-700">Verified</p>
				</TooltipContent>
			</Tooltip>
		</TooltipProvider>
	);
};

export default VerifiedBadgeCheck;
